import { useQuery } from '@tanstack/react-query';
import * as templateApi from '../services/issueTemplateService';

export const templateKeys = {
  list: (projectId: string) => ['issueTemplates', projectId] as const,
};

export function useIssueTemplates(projectId: string) {
  return useQuery({
    queryKey: templateKeys.list(projectId),
    queryFn: () => templateApi.fetchTemplates(projectId),
    staleTime: 5 * 60 * 1000, // 5분 캐시 (REQ-V19-014)
    enabled: !!projectId,
  });
}

export { templateApi as issueTemplateApi };
